import 'reflect-metadata'
import {
    InjectableType,
    ɵComponentType as ComponentType,
    ɵDirectiveType as DirectiveType,
    ɵComponentDef as ComponentDef,
    ɵDirectiveDef as DirectiveDef,
} from '@angular/core'

const store = {}
window['store'] = store
export function State(value?: string): PropertyDecorator {
    return (target: any, propertyKey: string | symbol) => {
        console.log(`Deco target: ${target.constructor.name}, propertyKey: ${String(propertyKey)}`)

        const isPatchedAlready = isDecorated(target)
        // console.log(`patched already? ${isPatchedAlready}`)
        const def = getDefFromConstr(target)
        if (!isPatchedAlready) {
            decorate(target)
            markAsDecorated(target)
        }
        target['_stateStoreAttrs'].push(String(propertyKey))
    }
}

function decorate(target) {
    console.log(`decorating...`)
    target['_stateStoreAttrs'] = []
    target['_stateStoreValues'] = {}
    const clazzName = target.constructor.name
    target['_saveState'] = function () {
        console.log(`** Doing save state of: ${clazzName} flag ${target['_stateStoreFlag']}`)
        if (target['_stateStoreFlag']) {
            return
        }
        target['_stateStoreFlag'] = true
        target['_stateStoreAttrs'].forEach((storeProperty) => {
            store[clazzName + '#' + storeProperty] = this[storeProperty]
            target['_stateStoreValues'][storeProperty] = this[storeProperty]
        })
        // console.log(`**Store state after(local): ${JSON.stringify(target['_stateStoreValues'])}`)
    }

    target['_restoreState'] = function (realThis) {
        console.log(`** Doing restore state of: ${clazzName} flag ${target['_stateStoreFlag']}`)
        target['_stateStoreFlag'] = false
        // console.log(`**Doing state restore of local data: ${JSON.stringify(this['_stateStoreValues'])}`)
        target['_stateStoreAttrs'].forEach((storeProperty) => {
            realThis[storeProperty] = target['_stateStoreValues'][storeProperty]
        })
    }
    const def = getDefFromConstr(target)
    const origOnInit = (def as any).onInit
    // console.log(`Patch the ngOninit, orig exists? ${!!origOnInit}`)
    ;(def as any).onInit = function () {
        // console.log(`** Monkey patched ngOnInit called on this: ${clazzName}`)
        target['_restoreState'].apply(this, [this])
        // tslint:disable-next-line: no-unused-expression
        origOnInit && origOnInit.call(this)
    }

    const origOnDestroy = (def as any).onDestroy
    // console.log(`Patch the onDestroy, orig exists? ${!!origOnDestroy}`)
    ;(def as any).onDestroy = function () {
        // console.log(`** Monkey patched onDestroy called on this: ${clazzName}`)
        target['_saveState'].apply(this)
        // for (const prop in this) {
        //     if (this[prop] && typeof this[prop].unsubscribe === 'function') {
        //         this[prop].unsubscribe()
        //     } else {
        //         continue
        //     }
        // }
        // tslint:disable-next-line: no-unused-expression
        origOnDestroy && origOnDestroy.call(this)
    }
}

/**
 * Determines whether the provided `target` is some function
 * decorated with `@Injectable()`
 */
function isInjectableType(target: any): target is InjectableType<unknown> {
    return !!target.ɵprov
}

export interface StatefulOptions {
    name?: string
}
/**
 * Applied to instances and stores `Subject` instance when
 * no custom destroy method is provided.
 */
const DESTROY: unique symbol = Symbol('__destroy')

/**
 * Applied to definitions and informs that class is decorated
 */
const DECORATOR_APPLIED: unique symbol = Symbol('__stateStore')

/**
 * If we use the `untilDestroyed` operator multiple times inside the single
 * instance providing different `destroyMethodName`, then all streams will
 * subscribe to the single subject. If any method is invoked, the subject will
 * emit and all streams will be unsubscribed. We wan't to prevent this behavior,
 * thus we store subjects under different symbols.
 */
function getSymbol<T>(destroyMethodName?: keyof T): symbol {
    if (typeof destroyMethodName === 'string') {
        return Symbol(`__destroy__${destroyMethodName}`)
    } else {
        return DESTROY
    }
}
function isDecorated(target) {
    return (target as any)[DECORATOR_APPLIED]
}
function markAsDecorated(providerOrDef: InjectableType<unknown> | DirectiveDef<unknown> | ComponentDef<unknown>): void {
    ;(providerOrDef as any)[DECORATOR_APPLIED] = true
}

function ensureClassIsDecorated(instance: any): never | void {
    const constructor = instance.constructor
    const providerOrDef = isInjectableType(constructor) ? constructor : getDef(constructor)
    const missingDecorator = !(providerOrDef as any)[DECORATOR_APPLIED]

    if (missingDecorator) {
        throw new Error(
            'untilDestroyed operator cannot be used inside directives or ' +
                'components or providers that are not decorated with UntilDestroy decorator'
        )
    }
}
/**
 * As directive and component definitions are considered private API,
 * so those properties are prefixed with Angular's marker for "private"
 */
function getDef<T>(type: DirectiveType<T> | ComponentType<T>): DirectiveDef<T> | ComponentDef<T> {
    return (type as ComponentType<T>).ɵcmp || (type as DirectiveType<T>).ɵdir
}
function getDefFromConstr(target) {
    return target.constructor.ɵcmp
}

function decorateProvider(type: InjectableType<unknown>, options: StatefulOptions): void {
    type.prototype.ngOnDestroy = decorateNgOnDestroy(type.prototype.ngOnDestroy, options)
    type.prototype.onInit = decorateNgOnInit(type.prototype.onInit, options)
    markAsDecorated(type)
}

function decorateDirective(type: DirectiveType<unknown> | ComponentType<unknown>, options: StatefulOptions): void {
    const def = getDef(type)
    ;(def as any).onDestroy = decorateNgOnDestroy(type.prototype.ngOnDestroy, options)
    ;(def as any).onInit = decorateNgOnInit(type.prototype.ngOnInit, options)

    def['_stateStoreAttrs'] = ['TESTMM']

    def['_stateStore'] = function () {
        console.log(`-------Doing state store of: ${this}`)
        def['_stateStoreAttrs'].forEach((storeProperty) => {
            // store[clazzName + '#' + storeProperty] = this[storeProperty]
            console.log(` ___stateStore ${storeProperty} `)
        })

        console.log(`-----Store state after: ${JSON.stringify(store)}`)
    }
    markAsDecorated(def)
}

function decorateNgOnInit(ngOnInit: (() => void) | null | undefined, {}: StatefulOptions) {
    return function (this: any) {
        // Invoke the original `ngOnDestroy` if it exists
        // tslint:disable-next-line: no-unused-expression
        ngOnInit && ngOnInit.call(this)
        const symbol = getSymbol()
        console.log(`Inside by decoreated ngOnInit ${String(symbol)}`)
        // It's important to use `this` instead of caching instance
        // that may lead to memory leaks
        // completeSubjectOnTheInstance(this, getSymbol());

        // Loop through the properties and find subscriptions
        if (this._stateStore) {
            this._stateStore()
        } else {
            console.log(` NO STATE STORE METHOD`)
        }
        for (const property in this) {
            console.log(`Inside by decoreated ngOnInit prop ${property}`)

            // unsubscribe(this[property])
        }
    }
}
function decorateNgOnDestroy(ngOnDestroy: (() => void) | null | undefined, {}: StatefulOptions) {
    return function (this: any) {
        // Invoke the original `ngOnDestroy` if it exists
        // tslint:disable-next-line: no-unused-expression
        ngOnDestroy && ngOnDestroy.call(this)
        const symbol = getSymbol()
        console.log(`Inside by decoreated ngOnDestroy ${String(symbol)}`)
        // It's important to use `this` instead of caching instance
        // that may lead to memory leaks
        // completeSubjectOnTheInstance(this, getSymbol());

        // Loop through the properties and find subscriptions

        for (const property in this) {
            console.log(`Inside by decoreated ngOnDestroy prop ${property}`)

            // unsubscribe(this[property])
        }
    }
}
export function Stateful(options: StatefulOptions = {}): ClassDecorator {
    return (target: any) => {
        // console.log(`Stateful deco`)
        // if (isInjectableType(target)) {
        //     decorateProvider(target, options)
        // } else {
        //     decorateDirective(target, options)
        // }
    }
}
